import * as moment from "moment";
import * as React from "react";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMessageHeaderSummary from "../../types/IMessageHeaderSummary";

interface IMessageRowProps extends IMessageHeaderSummary, ITranslationProps {
    onclick: (messageID: number, messageType: string) => void;
}

function MessageRow(p: IMessageRowProps) {

    function onRowClick() {
        p.onclick(p.id, p.messageType);
    }

    const messageDate = moment(p.dateTimeCreated).format(Constants.MOMENT_FORMAT_DATETIME);

    return (
        <tr onClick={onRowClick} className="message-row" title={p.t("Global.ClickForDetails")}>
            <td>{p.referenceID}</td>
            <td>{truncate(p.description)}</td>
            <td>{p.isHtmlFormat ? <em>&lt;html&gt;...&lt;/html&gt;</em> : truncate(p.messageContent)}</td>
            <td>{messageDate} </td>
            <td>{p.messageType}</td>
        </tr>
    );
}

function truncate(text: string) {
    if (text && text.length > 50) {
        return text.substr(0, 50) + "...";
    }
    return text;
}


export default translateComponent(MessageRow);



// WEBPACK FOOTER //
// ./src/components/MessageList/MessageRow.tsx